import { Injectable } from '@angular/core';
import { AbstractDataServiceDtoSummaryAdapter } from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import { PaymentRequestOnlineAttemptDataService } from './paymentRequestOnlineAttemptData.service';
import { PaymentRequestOnlineAttemptSummaryModel } from '../../../api/entity/paymentRequestOnlineAttemptSummary.model';
import { PaymentRequestOnlineAttemptSummaryConverter } from '../../../api/entity/converter/paymentRequestOnlineAttemptSummary.converter';
import { PaymentRequestOnlineAttemptModel } from '../../../api/entity/paymentRequestOnlineAttempt.model';

@Injectable({
    providedIn: 'root'
})
export class PaymentRequestOnlineAttemptSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<
    PaymentRequestOnlineAttemptSummaryModel,
    PaymentRequestOnlineAttemptSummaryConverter,
    PaymentRequestOnlineAttemptModel
> {
    constructor(dataService: PaymentRequestOnlineAttemptDataService, converter: PaymentRequestOnlineAttemptSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): PaymentRequestOnlineAttemptModel {
        return new PaymentRequestOnlineAttemptModel();
    }
}
